// Generated by CoffeeScript 2.7.0
var Assignment, Operation, uuid;

import BaseModel from '../base_model.js';

import Fieldable from '../concerns/fieldable.js';

import Journey from './journey.js';

import Response from '../response.js';

import Utilities from 'helpers/utilities.js';

({uuid} = Utilities);

Operation = class Operation {
  constructor(action, attrs) {
    this.action = action;
    this.uuid = uuid();
    _.extend(this, attrs);
  }

};

export default Assignment = (function() {
  class Assignment extends BaseModel {
    constructor(attrs = {}) {
      super(attrs);
      this.journey = new Journey(attrs.journey);
      this.response = new Response(attrs.response);
      this._makeFields(attrs.fields);
    }

    setOperations(current_vertex) {
      this.currentVertex = current_vertex;
      return this.operations = (function() {
        switch (this.category) {
          case 'proposed':
            switch (this.journey.status) {
              case 'processing':
                return this._generateOpretoions(['cancel', 'remind', 'repropose']);
              case 'receding':
                return this._generateOpretoions(['cancel', 'propose', 'repropose']);
              case 'stashed':
                return this._generateOpretoions(['stash', 'propose']);
              default:
                return this._generateOpretoions(['repropose']);
            }
            break;
          case 'processed':
            switch (this.status) {
              case 'processing':
                return this._generateOpretoions(['transfer', 'refuse', 'approve']);
              default:
                return [];
            }
            break;
          default:
            return [];
        }
      }).call(this);
    }

    _generateOpretoions(actions) {
      return _.chain(actions).map((action) => {
        return this._generateOpretoion(action);
      }).compact().value();
    }

    _generateOpretoion(action) {
      if (this.currentVertex.dig('operations', action, 'enabled')) {
        return new Operation(action, this.currentVertex.dig('operations', action));
      }
    }

  };

  Assignment.setAttributes(['id', 'message_required', 'phase', 'response', 'category', 'status', 'hourglass', 'processed_delay_requests']);

  return Assignment;

}).call(this);

Assignment.assemble(Fieldable);
